import type { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly hasError?: boolean
}

/**
 * Form input. White bg, 1.5px border, focus = forest border.
 * Per SOP 13 visual rules.
 */
export function Input({ hasError = false, className, ...rest }: InputProps): JSX.Element {
  const classes = [
    'w-full font-body text-body px-3 py-2 rounded-md',
    'bg-white border-[1.5px] outline-none transition',
    hasError ? 'border-terra focus:border-terra' : 'border-border focus:border-forest',
    'placeholder:text-stone-400',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ')

  return <input className={classes} {...rest} />
}
